const animalTypes = {
  3: "Schaap",
  4: "Geit",
};

export default animalTypes;
